module.exports = __webpack_public_path__ + "static/coursebg-700052786e871db6e22051e24a7dd7fb.jpeg";